import { forwardRef } from 'react';
import { Group } from 'three';

import {
  AccumulativeShadows,
  AccumulativeShadowsProps,
  ContactShadows,
  ContactShadowsProps,
  RandomizedLight,
} from '@react-three/drei';
import { GroupProps } from '@react-three/fiber';

export type ShadowsProps = Omit<GroupProps, 'scale'> &
  (
    | ({
        type?: 'contact';
      } & ContactShadowsProps)
    | ({
        type?: 'accumulative';
      } & AccumulativeShadowsProps)
  );
/**
 * A component that adds shadows to the scene.
 */
export const Shadows = forwardRef<Group, ShadowsProps>(
  ({ type = 'contact', ...restProps }, ref) => {
    const ShadowComponent = type === 'contact' ? ContactShadows : AccumulativeShadows;
    return (
      <ShadowComponent
        ref={ref}
        frames={2}
        position={[0, -0.01, 0]}
        scale={100 as any}
        {...(restProps as any)}
      >
        <RandomizedLight amount={4} position={[5, 5, -10]} radius={8} />
      </ShadowComponent>
    );
  }
);

export default Shadows;
